import { getDefaultSelectedCurrencyAndContinent, PosCurrency } from '@accor/core-services/src/pos'
import { env } from '@accor/customer-core'
import type { AccorCurrencies, UpdateCurrency } from '@accor/core-services/src/pos'

export type SelectedCurrencyItem = {
  currency: string
  symbole: string
}

export type SelectedCurrencyDropdown = {
  currency: string
  continent: string
}

export type SelectedCurrency = {
  currencyItem: SelectedCurrencyItem
  currencyDropdown: SelectedCurrencyDropdown
}

export type SelectedActionData = [
  string,
  {
    attributes: [
      {
        'data-continent': string
        'data-currency': string
      }
    ]
    currencyCode: string
    currencyLabel: string
    currencySymbol: string
    text: string
    value: string
  }
]

function getCurrencyService() {
  const currencyService = PosCurrency.getInstance()
  currencyService.apiKey = `${env.config.apiKey}`
  currencyService.apiEntryPoint = `${env.config.apiAccorComApi}/referential/v1/pos`
  return currencyService
}

export async function getSelectedCurrency(): Promise<SelectedCurrency> {
  try {
    const selectedCurrencyAndContinent = await getDefaultSelectedCurrencyAndContinent()

    const currencyItem = {
      currency: selectedCurrencyAndContinent.currency,
      symbole: selectedCurrencyAndContinent.currencySymbol
    }

    const currencyDropdown = {
      currency: selectedCurrencyAndContinent.currency,
      continent: selectedCurrencyAndContinent.continent
    }

    return { currencyItem, currencyDropdown }
  } catch (error) {
    console.error('An error occurred while getting selected currency:', error)
    throw error
  }
}

export async function getAccorCurrencies(): Promise<AccorCurrencies> {
  try {
    const currencyService = getCurrencyService()
    return await currencyService.getCurrency()
  } catch (error) {
    console.error('An error occurred while getting currency:', error)
    return { continents: [], currencies: [] }
  }
}

export async function updateCurrency(
  selectedData: SelectedActionData
): Promise<UpdateCurrency | undefined> {
  try {
    const currencyService = getCurrencyService()
    const selectedCurrency = selectedData[1].currencyCode
    const updatedCurrency = await currencyService.updateCurrency(selectedCurrency)

    if (updatedCurrency) {
      globalThis.location.reload()
    }
  } catch (error) {
    console.error('An error occurred while updating currency:', error)
    return undefined
  }
}
